<template>
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '売上'" :CellValue="MikomiTypeData.sales+''" :CellTextColor="SalesTextColor" :CellColor="CellColor" />
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '総益仮'" :CellValue="MikomiTypeData.provProfit+''" :CellTextColor="ProvProfitColor" :CellColor="CellColor" />
    <Mikomi_Cell :CellTitle="CellTitlePrefix + '総益仮(率)'" :CellValue="`${MikomiTypeData.sales !== 0 ? ((MikomiTypeData.provProfit/MikomiTypeData.sales) * 100).toFixed(1) : 0}%`" :CellTextColor="ProvProfitRateColor" :CellColor="CellColor" />
</template>

<script>
import Mikomi_Cell from './Mikomi_Cell.vue';
export default{
    components:{
        Mikomi_Cell
    },
    computed:{
        SalesTextColor()
        {
            return this.MikomiTypeData.sales >= 0 ? '#000' : '#a00';
        },
        ProvProfitColor()
        {
            return this.MikomiTypeData.provProfit >= 0 ? '#000' : '#a00';
        },
        ProvProfitRateColor()
        {
            const rate = this.MikomiTypeData.sales !== 0 ? ((this.MikomiTypeData.provProfit/this.MikomiTypeData.sales) * 100).toFixed(1) : 0;
            return rate >= 0 ? '#000' : '#a00';
        }
    },
    props:{
        MikomiTypeData:Object,
        CellTitlePrefix:String,
        CellColor: String,
    }
}
</script>